/**
 * Created by forbiz on 2019-02-11.
 */


const layout = () => {
    
}

export default layout;